import { useIoContext, useStoreActions, useStoreStatic } from "../contexts";
import { useOverlayContext } from 'seagull';
import { selectors } from "../store/state-selectors";
import { KycCompletionStatus } from "../store/store.model";
import { InquiryStatusEnum, KYBProgressStatusEnum } from 'anchor-kyb-service/types';
import { handlePromise } from "../infra/utils";
import { useFeatureFlags } from "./useFeatureFlags";
const personaInquiryLoader = 'persona-inquiry';
export function shouldStartPersonaKYC(_ref) {
  let {
    personaKycStatus,
    stripeKycStatus
  } = _ref;
  const hasPersonaFailed = personaKycStatus === KYBProgressStatusEnum.Declined || personaKycStatus === KYBProgressStatusEnum.Errored;
  const neverStartedStripeKYC = stripeKycStatus === KycCompletionStatus.InitialIncomplete;
  const isPendingMigrationFromStripeToPersona = stripeKycStatus === KycCompletionStatus.Completed && personaKycStatus != null && [KYBProgressStatusEnum.NotStarted, KYBProgressStatusEnum.DetailsNeeded].includes(personaKycStatus);
  return hasPersonaFailed || neverStartedStripeKYC || isPendingMigrationFromStripeToPersona;
}
export function useStartKYC() {
  const {
    personaClient,
    openNewTab
  } = useIoContext();
  const {
    api,
    fetchPersonaKYBStatus
  } = useStoreActions();
  const {
    getState
  } = useStoreStatic();
  const {
    startLoader,
    stopLoader,
    showErrorToast
  } = useOverlayContext();
  const {
    KYB_VERIFICATION,
    KYB_LIVENESS_V2
  } = useFeatureFlags();
  async function startKYCPersona(businessId) {
    startLoader(personaInquiryLoader);
    const result = await handlePromise(KYB_VERIFICATION || KYB_LIVENESS_V2 ? api.vendor.getKYBInquiryWithSelfie(businessId) : api.vendor.getKYBInquiry(businessId));
    if (result.success) {
      const {
        inquiryId,
        sessionToken,
        inquiryStatus
      } = result.data;
      if (InquiryStatusEnum.NeedsReview === inquiryStatus) {
        await fetchPersonaKYBStatus();
        stopLoader(personaInquiryLoader);
        return;
      }
      const client = personaClient({
        onError: () => stopLoader(personaInquiryLoader),
        onReady: () => stopLoader(personaInquiryLoader),
        onComplete: () => fetchPersonaKYBStatus()
      });
      client.open(inquiryId, sessionToken);
    } else {
      showErrorToast('Failed to start KYB process');
      stopLoader(personaInquiryLoader);
    }
  }
  async function startKYCStripe(businessId) {
    const url = await api.vendor.getStripeHostedKYBUrl(businessId);
    openNewTab(url);
  }
  async function startKYC() {
    var _getState$personaKYBS;
    const worksAt = selectors.user.business(getState());
    const businessId = worksAt === null || worksAt === void 0 ? void 0 : worksAt.id;
    const stripeKycStatus = worksAt === null || worksAt === void 0 ? void 0 : worksAt.kycCompletionStatus;
    const personaKycStatus = (_getState$personaKYBS = getState().personaKYBStatus.data) === null || _getState$personaKYBS === void 0 ? void 0 : _getState$personaKYBS.status;
    if (businessId == null) {
      return;
    }
    if (shouldStartPersonaKYC({
      personaKycStatus,
      stripeKycStatus
    })) {
      startKYCPersona(businessId);
    } else {
      startKYCStripe(businessId);
    }
  }
  return {
    startKYC
  };
}